module.exports = __webpack_public_path__ + "img/q16.bf21af2d.png";